import React from 'react';

import BadesulAddress from './BadesulAddress';

const BadesulAddressWrapper = ({ selectedBusinessUser, form }) => {
  if (!selectedBusinessUser || !selectedBusinessUser.user) {
    return null;
  }

  return (
    <div className="badesul-address-wrapper" style={{ padding: '1rem' }}>
      <BadesulAddress address={selectedBusinessUser.user.address ?? {}} form={form} />
    </div>
  );
};

export default BadesulAddressWrapper;
